export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发票详情"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发票"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建日期"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结束日期"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发票金额"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["佣金"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商店ID"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商店名称"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["备注："])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易ID"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支付方式"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["转换率"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支付信息"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支付链接"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["总计"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扣除佣金后记入商店的金额。"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["导出PDF"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回调"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["链接"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发票信息"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已发送"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已接收"])},
  "25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回复"])},
  "26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["时间"])},
  "28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["显示全部"])},
  "29": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐藏"])},
  "30": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已付金额"])},
  "31": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["附加费用"])},
  "32": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内部账户"])}
}